import { IClassname } from '@/lib/shared/model/classname';

export const Toiletry = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14249_7515)">
        <path
          d="M11.5273 26.8621H3.85982L1.30398 2.00657C1.29503 1.91745 1.30491 1.82745 1.33298 1.74239C1.36106 1.65734 1.4067 1.57913 1.46695 1.51286C1.5272 1.44658 1.60071 1.39372 1.68271 1.35769C1.76471 1.32166 1.85338 1.30327 1.94294 1.30372H13.4442C13.5338 1.30327 13.6224 1.32166 13.7044 1.35769C13.7864 1.39372 13.8599 1.44658 13.9202 1.51286C13.9804 1.57913 14.0261 1.65734 14.0542 1.74239C14.0822 1.82745 14.0921 1.91745 14.0832 2.00657L11.5273 26.8621Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.85986 26.8623H11.5274V29.4181C11.5274 29.7571 11.3927 30.0821 11.1531 30.3218C10.9134 30.5614 10.5884 30.6961 10.2494 30.6961H5.13778C4.79886 30.6961 4.47381 30.5614 4.23416 30.3218C3.9945 30.0821 3.85986 29.7571 3.85986 29.4181V26.8623Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.62866 5.1377H13.7586"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.7792 1.30371C28.7792 1.30371 30.6961 1.30371 30.6961 3.22059V28.7789C30.6961 28.7789 30.6961 30.6958 28.7792 30.6958C28.7792 30.6958 26.8623 30.6958 26.8623 28.7789V3.22059C26.8623 3.22059 26.8623 1.30371 28.7792 1.30371Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3064 2.58203H20.4727"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3064 5.1377H20.4727"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3064 7.69336H20.4727"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3064 10.249H20.4727"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14249_7515">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
